import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { InventoryService } from 'src/app/services/inventory.service';
import { tryParseJSONObject } from 'src/app/tools/try-parse-json';

@Component({
  selector: 'app-new-item-template',
  templateUrl: './new-item-template.component.html',
  styleUrls: ['./new-item-template.component.scss']
})
export class NewItemTemplateComponent implements OnInit {

  public defaultTemplate: any = {
    name: "",
    nicename: "",
    definition: [
      {
        component: "title",
        data: {
          title: null,
          readonly: false
        }
      },
      {
        component: "ebay",
        data: {}
      },
      {
        component: "sell",
        data: {
          StartingPrice: 0
        }
      },
      {
        component: "features",
        data: {
          allowAdditional: true,
          required: []
        }
      },
      {
        component: "images",
        data: {
          placeholderPath: null,
          required: []
        }
      }]
  };

  public json: string = "";
  public name: string = "";

  public nameWarning = false;

  constructor(private inventoryService: InventoryService,
    private router: Router) {}
  
  ngOnInit() {

  }

  create() {
    let templateToSend = null;

    templateToSend = this.defaultTemplate;

    if (templateToSend != null && this.name !== "") {
      templateToSend.nicename =  this.name;
      templateToSend.name = this.name.replace(/([^a-z0-9]+)/gi, "-").toLowerCase();

      this.inventoryService.createItemTemplate(templateToSend).subscribe(r => {
        this.router.navigate(['/settings/item-template-editor', templateToSend.name])
      });
    } else {
      this.nameWarning = true;
    }

  }

}
